import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {sessionSelector} from 'store/auth/sessionSlice';
import {LoadSelectTenant} from 'views/tenant';

interface AuthorityGuardProps {
    children: React.ReactNode;
}
export const TenantGurd: React.FC<AuthorityGuardProps> = ({children}) => {
    const {tenantId} = useParams();
    const {tenantSlug} = useSelector(sessionSelector);
    const renderComponent = useMemo((): React.ReactNode => {
        if (tenantId && tenantId !== tenantSlug) {
            return <LoadSelectTenant />;
        } else {
            return <>{children}</>;
        }
    }, [tenantId, tenantSlug]);

    return <>{renderComponent}</>;
};

export default TenantGurd;
